import React, { useState, useEffect, useContext } from "react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useMutation, useManualQuery, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import update from "immutability-helper";
import styled from "styled-components";
import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";

import {
  EDIT_TENANT_MUTATION,
  GET_TENANT_DATA_BY_USER,
  UPDATE_TENANT_COUNTRIES,
} from "../../graphQL/tenant_qry";

import penImg from "../../assets/icons/pen.png";
import trashImg from "../../assets/icons/trash.png";
import AlertDialog from "../../components/AlertDialog.js";
//import MultipleInputsDialog from "../../components/MultipleInputsDialog.js";
import ManageCountryInputsDialog from "../../components/ManageCountryInputsDialog.js";
import { project_url } from "../../constants/Data";

import Header from "./Header.js";

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7.5rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    //  paddingTop:theme.spacing(2),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
  },

  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    // "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
    //   position: "relative",
    //   display: "block",
    // },
    "&.MuiDataGrid-root": {
      //paddingTop:10,
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 12,
    },
  },
}));

function ManageCountries() {
  const [loadData, setLoadData] = useState(false);
  const [loadContent, setLoadContent] = useState(false);

  const [pageSize, setPageSize] = useState(20);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);

  const [countriesData, setCountriesData] = useState([]);
  const [countriesUpdatedData, setCountriesUpdatedData] = useState([]);
  const [alertDeleteMsg, setAlertDeleteMsg] = useState([]);
  const [manageCountryInputsDialogMsg, setManageCountryInputsDialogMsg] = useState([]);
  const [alertDoneMsg, setAlertDoneMsg] = useState([]);
  const [lastUpdate, setLastUpdate] = useState(["10/27/2024"]);

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");

  const [access, setAccess] = useState(true);
  const [viewAccess, setViewAccess] = useState(false);
  const [addAccess, setAddAccess] = useState(false);
  const [editAccess, setEditAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "General Settings",
              modulepageName: "Manage Countries"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {      
      setAccess(accessData.staffModuleAccess.access);
      let commonActions = accessData.staffModuleAccess.commonActions.split('|');
      if(commonActions.find(a => a == "View"))
        setViewAccess(true)
      if(commonActions.find(a => a == "Add"))
        setAddAccess(true)
      if(commonActions.find(a => a == "Edit"))
        setEditAccess(true)
      if(commonActions.find(a => a == "Delete"))
        setDeleteAccess(true)

      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = day => {
    const dayDate = new Date(day);
    const dayFormat = formatter.formatToParts(dayDate);
    const newFormat =
      dayFormat.find(a => a.type == "month").value +
      "/" +
      dayFormat.find(a => a.type == "day").value +
      "/" +
      dayFormat.find(a => a.type == "year").value;
    return newFormat;
  };

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };
  const [getUserTenantData] = useManualQuery(GET_TENANT_DATA_BY_USER, {
    fetchPolicy: "network-only",
  });

  const [editTenant] = useMutation(EDIT_TENANT_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [updateTenantCountriesMutation] = useMutation(UPDATE_TENANT_COUNTRIES);

  const getTenant = async () => {
    // Get tenant information
    const {
      loading: tenantDataLoading,
      error: tenantDataError,
      data: tenantData,
    } = await getUserTenantData();

    if (!tenantDataLoading && tenantData && tenantData.getUserTenantData) {
      let countries = [];
      let allData = tenantData.getUserTenantData.countries.split("updateDate");
      if (allData.length > 2) {
        let userUpdateDate = "";
        JSON.parse(tenantData.getUserTenantData.countries).map((item, index) => {
          countries.push({
            index: index,
            countryName: item.fields.countryName,
            countryCode: item.fields.countryCode,
            desc: item.fields.desc,
          });
          userUpdateDate = item.fields.updateDate;
        });
        setLastUpdate(dayFormat(userUpdateDate));
      } else {
        JSON.parse(allData[0]).map((item, index) => {
          countries.push({
            index: index,
            countryName: item.countryName,
            countryCode: item.countryCode,
            desc: item.desc,
          });
        });
        setLastUpdate(dayFormat(allData[1]));
      }
      
      setCountriesData(countries);
      setCountriesUpdatedData(countries);

      setLoadData(true);
    }
    if (
      tenantDataError &&
      tenantDataError.graphQLErrors &&
      tenantDataError.graphQLErrors[0].message === "Signature has expired"
    ) {
      navigate(`${project_url}/signin`);
    }
  };
  const rows = countriesUpdatedData.map(country => ({
    index: country.index,
    name: country.countryName,
    code: country.countryCode,
    desc: country.desc,
    editAccess : editAccess,
    deleteAccess: deleteAccess,
  }));
  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getTenant())();
  }, []);

  const updateCountry = (values, index) => {
    const findCountryIndex = countriesUpdatedData.findIndex(item => item.index === index);

    if (findCountryIndex !== -1) {
      countriesUpdatedData[findCountryIndex]["countryName"] = values[0];
      countriesUpdatedData[findCountryIndex]["countryCode"] = values[1];
      countriesUpdatedData[findCountryIndex]["desc"] = values[2];

      countriesUpdatedData.sort((a, b) =>
        b.countryName.toLowerCase() < a.countryName.toLowerCase() ? 1 : -1
      );

      setManageCountryInputsDialogMsg([]);
    }
  };
  const deleteCountry = index => {
    const findCountryIndex = countriesUpdatedData.findIndex(item => item.index === index);
    const updatedList = update(countriesUpdatedData, {
      $splice: [[findCountryIndex, 1]],
    });
    setCountriesUpdatedData(updatedList);
    setManageCountryInputsDialogMsg([]);
  };
  const AddCountry = values => {
    let maxIndex = 0;
    countriesUpdatedData.map(el => {
      maxIndex = Math.max(maxIndex, el.index);
    });

    const newCountry = {
      index: maxIndex + 1,
      countryName: values[0],
      countryCode: values[1],
      desc: values[2],
    };

    const updatedList = update(countriesUpdatedData, {
      $push: [newCountry],
    });
    updatedList.sort((a, b) =>
      b.countryName.toLowerCase() < a.countryName.toLowerCase() ? 1 : -1
    );
    setCountriesUpdatedData(updatedList);
    setManageCountryInputsDialogMsg([]);
  };

  const updateCountries = async () => {
    let tenantId = null;
    if (localStorage.getItem("tenantId")) {
      tenantId = localStorage.getItem("tenantId");
    } else {
      alert("The Id of the Tenant is not defined.");
      return;
    }

    let {
      loading: loadMutation,
      error: errorMutation,
      data: dataMutation,
    } = await updateTenantCountriesMutation({
      variables: {
        tenantId: parseInt(tenantId),
        updateValue: JSON.stringify(countriesUpdatedData),
      },
    });
    if (!loadMutation && dataMutation.updateTenantCountries.response) {
      setAlertDoneMsg({
        title: "Success",
        msg: "Country records are successfully updated.",
      });
    } else {
      alert(errorMutation);
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Country Name",
      minWidth: 200,
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
    },
    {
      field: "code",
      headerName: "Country Code",
      minWidth: 80,
      flex: 1,
      sortable: true,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "desc",
      headerName: "Description",
      minWidth: 200,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "action",
      headerName: "Action",
      minWidth: 100,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        var editFilter = rows.row.editAccess ? "none" : "grayscale(1)";
        var editOpacity = rows.row.editAccess ? 1 : 0.5;
        var editCursor = rows.row.editAccess ? "pointer" : "auto";

        var deleteFilter = rows.row.deleteAccess ? "none" : "grayscale(1)";        
        var deleteOpacity = rows.row.deleteAccess ? 1 : 0.5;        
        var deleteCursor = rows.row.deleteAccess ? "pointer" : "auto";

        return (
          <Box
            pt={1}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <StyledTooltip title="Edit">
              <img
                style={{
                  paddingRight: 15,
                  cursor: editCursor,
                  paddingTop: 6,
                  height: 24,
                  weight: 24,
                  filter: editFilter,
                  opacity: editOpacity,
                }}
                src={penImg}
                onClick={() =>
                  rows.row.editAccess ?
                  (
                    setManageCountryInputsDialogMsg({
                      title: "Edit Country",
                      index: rows.row.index,
                      values: [rows.row.name, rows.row.code, rows.row.desc],
                      msg: ["Name", "Code", "Description"],
                      type: "Edit",
                    })
                  )
                  : ""
                }
              />
            </StyledTooltip>
            <StyledTooltip title="Delete">
              <img
                style={{
                  paddingRight: 15,
                  cursor: deleteCursor,
                  paddingTop: 6,
                  height: 24,
                  weight: 24,
                  filter: deleteFilter,
                  opacity: deleteOpacity,
                }}
                src={trashImg}
                onClick={() =>
                  rows.row.deleteAccess ?
                  (
                      setAlertDeleteMsg({
                        title: "Delete Country",
                        type: "deleteConfirmation",
                        msg:
                          "Are you sure you want to delete country “" + rows.row.name + "”?",
                        index: rows.row.index,
                      })
                  )
                  :""
                }
              />
            </StyledTooltip>
          </Box>
        );
      },
    },
  ];

  const classes = useStyles();
  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 5,
            paddingBottom: 6,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={2}>
            <Box
              sx={{
                p: 0.5,
                pb: 0,
              }}
            >
              <GridToolbarQuickFilter />
            </Box>
          </Grid>
          <Grid
            item
            xs={8}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography variant="body1">Manage Countries</Typography>
            <Typography variant="h5" style={{ paddingLeft: 10, paddingTop: 3 }}>
              (Last Updated: {lastUpdate})
            </Typography>
          </Grid>
          <Grid
            item
            xs={2}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: 10,
            }}
          >
            <Button
              variant="contained"
              size="small"
              className={classes.buttonStyle}
              disabled = {!addAccess ? "disabled" : ""}
              onClick={() =>
                addAccess ?
                (
                    setManageCountryInputsDialogMsg({
                      title: "Add Country",
                      msg: ["Name", "Code", "Description"],
                      type: "Add",
                    })
                )
                :""
              }
            >
              Add
            </Button>
          </Grid>
        </Grid>
        <Divider />
      </>
    );
  }
  
  if (loadContent && loadData)
    if (access)
    return (
      <div className={classes.root}>
        <Header
          breadcrumbs={[
            { label: "General Settings", link: null },
            { label: "Manage Countries", link: null },
          ]}
        />
        <div className={classes.container}>
          <Box mb={3} />
          <DataGrid
            className={classes.dataGridStyle}
            columns={columns}
            rows={rows}
            showCellRightBorder={true}
            // hideFooter={true}
            slots={{
              toolbar: DataGridTitle,
            }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
              },
            }}
            getRowId={row => row.index}
            autoHeight={true}
            experimentalFeatures={{ newEditingApi: true }}
            initialState={{
              pagination: { paginationModel: { pageSize: 20 } },
            }}
            pageSizeOptions={[20, 50, 100]}
          />
          <Box pt={4} pb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 2, width: "150px" }}
              onClick={updateCountries}
            >
              Update Countries
            </Button>

            <Button
              variant="text"
              color="primary"
              className={classes.outlinedButtonStyle}
              onClick={() => navigate(`${project_url}/tenant/dashboard`)}
            >
              Cancel
            </Button>
          </Box>
          {alertDeleteMsg.msg && (
            <AlertDialog
              title={alertDeleteMsg.title}
              type={alertDeleteMsg.type}
              contentMsg={alertDeleteMsg.msg}
              closeDialog={() => setAlertDeleteMsg([])}
              deleteAction={() => {
                setAlertDeleteMsg([]);
                deleteCountry(alertDeleteMsg.index);
              }}
            />
          )}
          {manageCountryInputsDialogMsg.msg && (
            <ManageCountryInputsDialog
              title={manageCountryInputsDialogMsg.title}
              text={manageCountryInputsDialogMsg.text}
              values={manageCountryInputsDialogMsg.values}
              data={countriesUpdatedData}
              contentMsg={manageCountryInputsDialogMsg.msg}
              closeDialog={() => setManageCountryInputsDialogMsg([])}
              addEditDialog={values => {
                if (manageCountryInputsDialogMsg.type === "Edit")
                  updateCountry(values, manageCountryInputsDialogMsg.index);
                if (manageCountryInputsDialogMsg.type === "Add") AddCountry(values);
              }}
            />
          )}
          {alertDoneMsg.msg && (
            <AlertDialog
              title={alertDoneMsg.title}
              contentMsg={alertDoneMsg.msg}
              closeDialog={() => navigate(`${project_url}/tenant/dashboard`)}
            />
          )}
        </div>
      </div>
    );
  
  else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
}

export default ManageCountries;
